import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { EditorPage } from './pages/EditorPage'
import { GalleryPage } from './pages/GalleryPage'
import { ExampleEditorPage } from './pages/ExampleEditorPage'
import ToolNav from '../shared/ToolNav'

export default function App() {
  return (
    <BrowserRouter>
      <ToolNav current="/motion-playground" />
      <Routes>
        <Route path="/motion-playground" element={<GalleryPage />} />
        <Route path="/motion-playground/examples/:categorySlug" element={<GalleryPage />} />
        <Route path="/motion-playground/edit/:exampleId" element={<ExampleEditorPage />} />
        <Route path="/motion-playground/sandbox" element={<EditorPage />} />
        <Route path="*" element={<Navigate to="/motion-playground" replace />} />
      </Routes>
    </BrowserRouter>
  )
}
